import { logE, log } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import { VesselRatings, VoyageAssesmentFormM } from "../models/voyage-assesment.models";

export async function getVesselRatings(
  imoNumber: string | undefined,
  vesselCode: string | undefined,
  vesselName: string | undefined,
): Promise<VesselRatings | undefined> {
  try {
    const resp = await api.get<VesselRatings>(`${apiUrl}/vesselRatings`, {
      params: {
        vesselName: vesselName ?? "",
        vesselCode: vesselCode ?? "",
        imoNumber: imoNumber ?? "",
      },
    });

    log("REPO - getVesselRatings - response", { hasData: resp.data != null });
    return resp.data;
  } catch (error) {
    logE(new Error("REPO - getVesselRatings - failed"));
    return;
  }
}

export async function saveVoyageAssesmentForm(
  form: VoyageAssesmentFormM,
  showConfirmation: () => void,
): Promise<string | null> {
  try {
    log("SERV - saveVoyageAssesmentForm");
    const url = `${apiUrl}/voyageAssesment`;
    const response = await api.post(url, form);
    log("REPO - saveVoyageAssesmentForm - response", { status: response.status });
  } catch (error: unknown) {
    logE(new Error("REPO - saveVoyageAssesmentForm - failed"));
    return error as string;
  }

  showConfirmation();
  return null;
}
export const getVoyageAssesmentStatus = async (tcCode: string, voyageNo: string): Promise<string> => {
  try {
    const resp = await api.get<string>(`${apiUrl}/voyageAssesmentStatus`, {
      params: {
        tcCode: tcCode ?? "",
        voyageNo: voyageNo ?? "",
      },
    });
    const data = resp.data as unknown as { status: string };
    log("REPO - getVoyageAssesmentStatus - response", { status: data.status });
    return data.status;
  } catch (error) {
    logE(new Error("REPO - getVoyageAssesmentStatus - failed"));
    return "pending";
  }
};
